// extracted by mini-css-extract-plugin
module.exports = {"heroHeader":"ortschaften_heroHeader__nPu7z","teesdorf":"ortschaften_teesdorf__BdqYo","tattendorf":"ortschaften_tattendorf__fvJ6G"};